import * as XLSX from "xlsx"

/**
 * Parse Excel with columns: cust_code, firstname, lastname (header row required).
 * Header names are matched case-insensitively; aliases: cust_code / custcode / customer_code
 */
export function parseCustomerImportExcel(arrayBuffer) {
  const workbook = XLSX.read(arrayBuffer, { type: "array" })
  const sheetName = workbook.SheetNames[0]
  const sheet = workbook.Sheets[sheetName]
  const rows = XLSX.utils.sheet_to_json(sheet, { defval: "" })

  const normalizeKey = k =>
    String(k || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "_")

  const getCode = row => {
    const keys = Object.keys(row)
    for (const k of keys) {
      const nk = normalizeKey(k)
      if (
        nk === "cust_code" ||
        nk === "custcode" ||
        nk === "customer_code" ||
        nk === "cust_no"
      ) {
        return String(row[k] ?? "").trim()
      }
    }
    return ""
  }

  const getFirst = row => {
    for (const k of Object.keys(row)) {
      if (normalizeKey(k) === "firstname" || normalizeKey(k) === "first_name") {
        return String(row[k] ?? "").trim()
      }
    }
    return ""
  }

  const getLast = row => {
    for (const k of Object.keys(row)) {
      if (normalizeKey(k) === "lastname" || normalizeKey(k) === "last_name") {
        return String(row[k] ?? "").trim()
      }
    }
    return ""
  }

  const result = []
  for (const row of rows) {
    const cust_code = getCode(row)
    if (!cust_code) continue
    result.push({
      cust_code,
      firstname: getFirst(row),
      lastname: getLast(row),
    })
  }
  return result
}
